<template>
  <div>
    <!-- 产品支持区块 -->
    <!-- <transition appear enter-active-class="animate__animated animate__fadeIn"> -->
    <div class="product-box box-class">
      <transition appear enter-active-class="animate__animated animate__fadeIn">
        <div class="product-title">产品支持</div>
      </transition>
      <transition
        appear
        enter-active-class="animate__animated animate__fadeIn animate__delay-0.5s"
      >
        <div class="product-title-tips">Services Support</div>
      </transition>
      <transition
        appear
        enter-active-class="animate__animated animate__fadeIn animate__delay-1s"
      >
        <div class="product-service">
          我们提供全方位的服务支持，确保您获得最佳的上门按摩体验
        </div>
      </transition>
      <transition
        appear
        enter-active-class="animate__animated animate__fadeInRight animate__delay-1.5s"
      >
        <!-- <div class="product-picture">
          <img src="@/assets/img/services_support_01.jpg" alt="" />
          <img src="@/assets/img/services_support_02.jpg" alt="" />
          <img src="@/assets/img/services_support_03.jpg" alt="" />
          <img src="@/assets/img/services_support_04.jpg" alt="" />
        </div> -->

        <div class="product-grid">
        <div
          class="product-card"
          v-for="(item, index) in gridList"
          :key="index"
        >
          <div class="product-icon">
            <i class="iconfont" :class="item.icon"></i>
          </div>
          <h3>{{ item.name }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
      </transition>
      
    </div>
    <!-- </transition> -->
    <!-- <div class="product-box box-class">
        <div class="product-title">产品支持</div>
        <div class="product-title-tips">Services Support</div>
        <div class="product-service">技术支持/人才服务/保障服务/其他服务</div>
        <div class="product-picture">
          <img src="@/assets/img/banner_01.png" alt="" v-for="i in 4" />
        </div>
      </div> -->

    <!-- 产品--轮播图 -->
    <div class="product-box box-class2">
      <div class="product-title">产品服务</div>
      <div class="product-title-tips">product Services</div>
      <!-- <div class="product-service">技术支持/人才服务/保障服务/其他服务</div> -->
      <!-- <div class="product-picture">
          <img src="@/assets/img/banner_01.png" alt="" v-for="i in 4"/>
        </div> -->
    </div>
    <div class="my-container">
      <swiper
        v-if="carouselList.length > 0"
        :options="swiperOption"
        ref="mySwiper"
        class="mySwiper"
      >
        <swiper-slide
          v-for="(item, index) in carouselList"
          :key="index"
          class="swiper-slide"
        >
          <div class="slide-content">
            <img :src="item.imgUrl" loading="lazy" />
            <div class="slide-title">{{ item.title }}</div>
          </div>
        </swiper-slide>

        <!-- 左右箭头 -->
        <!-- <div slot="button-prev" class="swiper-button-prev"></div>
          <div slot="button-next" class="swiper-button-next"></div> -->

        <!-- 如果需要分页器，可以添加以下代码 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "product",
  data() {
    return {
      name: "产品",
      gridList: [
        {
          icon: "icon-xiuli",
          name: "技术支持",
          desc: "专业的按摩技术支持，确保每次服务都能达到最佳效果",
        },
        {
          icon: "icon-duoren",
          name: "人才服务",
          desc: "严格筛选认证的专业按摩师，为您提供优质的服务体验",
        },
        {
          icon: "icon-xitongzhuangtai-baozhangzhuangtai",
          name: "保障服务",
          desc: "全方位的服务保障体系，让您安心享受每一次按摩服务",
        },
        {
          icon: "icon-dingcan",
          name: "其他服务",
          desc: "个性化定制服务，满足您的特殊需求和偏好",
        },
      ],
      carouselList: [
        {
          id: 1,
          imgUrl: require("@/assets/img/project01.jpg"),
          title: "泰皇尊享精油SPA",
        },
        {
          id: 2,
          imgUrl: require("@/assets/img/project02.jpg"),
          title: "古法泰式按摩",
        },
        {
          id: 3,
          imgUrl: require("@/assets/img/project03.jpg"),
          title: "改善睡眠头疗",
        },
        {
          id: 4,
          imgUrl: require("@/assets/img/project04.jpg"),
          title: "中式沉浸按摩",
        },
        {
          id: 5,
          imgUrl: require("@/assets/img/project05.jpg"),
          title: "怡福轻奢精油SPA",
        },
        // 添加更多slide数据
      ],
      swiperOption: {
        // 异形轮播效果，例如使用'coverflow'效果
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 0,
          slideShadows: true,
        },
        // 启用缩放效果
        zoom: {
          maxRatio: 2, // 设置最大缩放比例
          minRatio: 1, // 设置最小缩放比例
        },
        // 其他配置项
        centeredSlides: true,
        slidesPerView: 3,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //导航前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 如果需要分页器，可以取消以下代码的注释
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          //修改分页器样式
          bulletClass: "swiper-pagination-bullet",
          //激活样式
          bulletActiveClass: "my-bullet-active",
        },
        on: {
          slideChange: () => {
            if (this.$refs.mySwiper.$swiper) {
            }
          },
        },
      },
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted
    // //鼠标进入-暂停
    // this.$refs.mySwiper.$el.onmouseenter = () => {
    //   this.$refs.mySwiper.$swiper.autoplay.stop();
    // };
    // //鼠标离开-开始
    // this.$refs.mySwiper.$el.onmouseleave = () => {
    //   this.$refs.mySwiper.$swiper.autoplay.start();
    // };
  },
};
</script>

<style module>
:root {
  --swiper-theme-color: rgb(122, 158, 126);
}
</style>

<style lang="less" scoped>
.product-box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 35px 0;
  overflow: hidden;
  box-sizing: border-box;

  .product-title {
    font-size: 0.5692rem;
    font-weight: bold;
    color: #2c5530;
    padding: 5.0031px 6.0024px;
    border-bottom: 1px solid rgba(122, 158, 126, 0.4);
  }

  .product-title-tips {
    font-size: 0.1897rem;
    color: rgba(122, 158, 126, 0.8);
    margin-top: 0.0791rem;
  }

  .product-service {
    font-size: 0.2846rem;
    font-weight: 500;
    margin-top: 20px;
    color: #666;
  }

  .product-grid {
    width: 90%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    max-width: calc(320px * 2 + .3162rem * 4);

    .product-card {
      width: 5.0593rem;
      min-width: 220px;
      max-width: 320px;
      margin: .3162rem;
      background: white;
      border-radius: 15px;
      overflow: hidden;
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
      transition: transform 0.3s, box-shadow 0.3s;
      text-align: center;
      padding: 40px 30px;
      box-sizing: border-box;
    }

    .product-card:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    }

    .product-icon {
      width: 1.2648rem;
      height: 1.2648rem;
      background: #f0f7f0;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
    }

    .product-icon i {
      font-size: 0.5059rem;
      color: #2c5530;
    }

    h3 {
      font-size: .3478rem;
    }

    p {
      font-size: .2846rem;
    }
  }

  .product-picture {
    width: 8.6957rem;
    height: 4.7431rem;
    min-width: 275px;
    min-height: 190px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 35%;
      min-width: 100px;
      height: 40%;
      min-height: 80px;
      margin: 0.1581rem 0.3162rem;
      border-radius: 10px;
    }

    // width: 550px;
    // height: 350px;

    // img {
    //   width: 200px;
    //   height: 160px;
    //   margin: 10px 30px;
    // }
  }
}

.box-class {
  background-color: #f1f0ec;
}

.box-class2 {
  background-color: #ffffff;
  padding-bottom: 0px;
}

.my-container {
  width: 11.0672rem;
  height: 5.0593rem;
  min-height: 130px;
  overflow: hidden;
  margin: 0.4743rem auto;

  .mySwiper {
    width: 100%;
    height: 100%;

    .swiper-slide {
      width: 25%;
      height: 100%;
      /* 根据需要自定义slide的样式 */
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      transform: scale(0.8) !important;

      .slide-content {
        width: 100%;
        height: 90%;
        text-align: center;
        position: relative;

        img {
          width: 100%;
          height: auto;
          border-radius: 0.1581rem;
        }

        .slide-title {
          margin-top: 0.1581rem;
          font-size: 0.2846rem;
          // font-weight: bold;
          color: #000;
          position: absolute;
          top: 65%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
    }

    .swiper-slide-active {
      transform: scale(1) !important;
    }
  }
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 0.3162rem;
  font-weight: bold;
}

.swiper-button-prev {
  left: 0.1581rem;
}

.swiper-button-next {
  right: 0.1581rem;
}
</style>

<style type="text/css">
/* .swiper-pagination-bullet {
    width: 0.5375rem;
    height: 0.3794rem;
    display: inline-block;
    background: #999999;
    opacity: 0.2;
    margin: 0 5px;
    border-radius: 20px;
    transition-delay: 0s;
    transition-duration: 0.5s, 0.5s, 0.5s;
    transition-timing-function: ease, ease, ease;
    transition-delay: 0.5s, 0.5s, 0s;
  }

  .my-bullet-active {
    opacity: 1;
    background: blue;
    width: 1.7866rem;
    transition-delay: 0s;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Products.vue